class HttpClient {
  static baseURL = process.env.REACT_APP_API_URL || 'https://localhost:7166/api/';

  static async request(url, options = {}, useCache = false) {
    const fullUrl = url.startsWith('http') ? url : `${this.baseURL}${url}`;
    
    const config = {
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    };

    // Simple cache implementation
    const cacheKey = `${fullUrl}_${JSON.stringify(config)}`;
    if (useCache && options.method === 'GET') {
      const cached = sessionStorage.getItem(cacheKey);
      if (cached) {
        console.log('Using cached data for:', fullUrl);
        return JSON.parse(cached);
      }
    }

    try {
      const response = await fetch(fullUrl, config);
      
      if (!response.ok) {
        const errorText = await response.text();
        console.error('API Error:', {
          status: response.status,
          statusText: response.statusText,
          url: fullUrl,
          body: errorText
        });
        
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }

      const data = await response.json();
      
      // Cache successful GET requests
      if (useCache && options.method === 'GET' && data.success) {
        sessionStorage.setItem(cacheKey, JSON.stringify(data));
      }

      return data;
    } catch (error) {
      console.error('Request failed:', error);
      return {
        success: false,
        message: error.message || "A network error occurred.",
        errors: [error.message || "A network error occurred."],
      };
    }
  }

  static get(url, params = {}, useCache = false) {
    const searchParams = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        searchParams.append(key, value);
      }
    });

    const queryString = searchParams.toString();
    const fullUrl = queryString ? `${url}?${queryString}` : url;
    
    return this.request(fullUrl, { method: 'GET' }, useCache);
  }

  static post(url, data) {
    return this.request(url, {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }

  // ✅ FIX: Implement proper PUT method
  static put(url, data, queryParams = {}) {
    // Add query parameters if provided
    const searchParams = new URLSearchParams();
    Object.entries(queryParams).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        searchParams.append(key, value);
      }
    });

    const queryString = searchParams.toString();
    const fullUrl = queryString ? `${url}?${queryString}` : url;
    
    return this.request(fullUrl, {
      method: 'PUT', // ✅ Changed from POST to PUT
      body: JSON.stringify(data),
    });
  }

  // ✅ FIX: Implement proper DELETE method
  static delete(url, queryParams = {}) {
    // Add query parameters if provided
    const searchParams = new URLSearchParams();
    Object.entries(queryParams).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        searchParams.append(key, value);
      }
    });

    const queryString = searchParams.toString();
    const fullUrl = queryString ? `${url}?${queryString}` : url;
    
    return this.request(fullUrl, { 
      method: 'DELETE' // ✅ Changed from POST to DELETE
    });
  }
}

export default HttpClient;